enum AustralianState {
  NSW = "NSW",
  VIC = "VIC",
  QLD = "QLD",
  WA = "WA",
  SA = "SA",
  TAS = "TAS",
  ACT = "ACT",
  NT = "NT",
}

export default AustralianState